import React from "react";

import { Pill, PillVariants } from "src/base-components/Pill";

export type ValueWithColor = {
  value: string;
  color?: string | null;
};

type TagPillProps = {
  value: ValueWithColor | string;
  children?: React.ReactNode;
  size?: "sm" | "base" | "lg";
};

export const TagPill: React.FC<TagPillProps> = ({
  value,
  children,
  size = "sm",
}) => {
  const displayValue = typeof value === "string" ? value : value.value;
  const color = typeof value === "object" && value.color ? value.color : "gray";

  return (
    <Pill size={size} variant={color as PillVariants}>
      <Pill.Text>{children || displayValue}</Pill.Text>
    </Pill>
  );
};
